import styled from 'styled-components'

export const AlertWrapper = styled.div`
  .mantine-Alert-root {
    background: ${({ theme }) => theme.alerta.warning.background};
  }

  .mantine-Alert-message,
  .mantine-Alert-closeButton {
    color: ${({ theme }) => theme.cor9}!important;
  }

  .mantine-Alert-title {
    color: ${({ theme }) => theme.alerta.warning.color};
  }

  .mantine-Alert-icon {
    color: ${({ theme }) => theme.alerta.warning.color};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg > path {
    fill: ${({ theme }) => theme.alerta.warning.color};
  }
`
